import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core'

import { MetaService } from './meta.service'

/**
 * provide AND sets up the {@link MetaService}
 */
export function provideMetaService(): EnvironmentProviders {
  return makeEnvironmentProviders([
    MetaService,
    provideEnvironmentInitializer((): void => {
      // no need to call something - just inject it so angular creates it
      // constructor of MetaService does the setup work
      void inject(MetaService)
    }),
  ])
}
